export default __webpack_public_path__ + "static/media/area-76.53fdc3e2.jpg";